import type { ReactNode } from "react";
import { createContext, useContext } from "react";

export type AvatarStyle = "robot" | "organic";

export const AvatarBrandContext = createContext<string>("");

const AvatarStyleContext = createContext<AvatarStyle>("organic");

export function AvatarStyleProvider({
  children,
  value,
  brandMarkUrl = "",
}: {
  children: ReactNode;
  value: AvatarStyle;
  brandMarkUrl?: string;
}) {
  return (
    <AvatarBrandContext value={brandMarkUrl}>
      <AvatarStyleContext value={value}>{children}</AvatarStyleContext>
    </AvatarBrandContext>
  );
}

export function useAvatarStyle(): AvatarStyle {
  return useContext(AvatarStyleContext);
}
